import {defineStore} from 'pinia';
import {CheckoutPage, CustomerDetailsForm, ISelectCountry, Package} from "./types";
import {Language} from "../../types/dto/Language";
import {Integration} from "../../components/software-picker.vue";
import Ajax from "../../lib/Ajax";
import _ from "lodash";


export const useStore = defineStore('order', {
    state: () => {
        const orderedPackage = window.cw.orderedPackage as Package | null;
        const countries = (window.cw.countries ?? []) as ISelectCountry[];
        return {
            orderedPackage: orderedPackage as Package,
            allPackages: (window.cw.packages ?? []) as Package[],
            currentPage: CheckoutPage.SUBSCRIPTION as CheckoutPage,
            chosenAddons: [...orderedPackage?.addOns ?? []],
            language: window.cw.language as Language,
            countries: countries,
            customerDetails: {
                ...window.cw.profile,
                message: ''
            } as CustomerDetailsForm,
            chosenIntegration: null as Integration | null,
            brand: window.cw.brand,
            selectedCountries: countries.filter(c => c.code === "nl") as ISelectCountry[],
            extraCountryPrice: window.cw.extraCountryPrice as number,
            isValidNlVat: false,
            isCheckingNlVat: false,
            mollieProfileId: window.cw.mollieProfileId,
            mollieIsTestMode: window.cw.mollieIsTestMode,
        }
    },
    getters: {
        premiumPrice(): number {
              const lizaPremium = this.allPackages.find(p => p.abonnement.abonnement === "premium");
              if(lizaPremium)
                  return lizaPremium.abonnement.price;
              else 
                  return 0;
        },
        exclPrice(): number {
            return this.orderedPackage.abonnement.price + 
                this.chosenAddons.reduce((tot, curr) => tot + curr.price, 0) +
                (this.chargeableCountries.length * this.extraCountryPrice);
        },
        btwPrice(): number {
            return this.totalPrice - this.exclPrice;
        },
        totalPrice(): number {
            return this.exclPrice * (this.isValidNlVat ? 1 : 1.21);
        },
        canGoToPrevPage(): boolean {
            const currIndex = Object.values(CheckoutPage).indexOf(this.currentPage);
            const prevIndex = currIndex - 1;

            return prevIndex >= 0;
        },
        canGoToNextPage(): boolean {
            const currIndex = Object.values(CheckoutPage).indexOf(this.currentPage);
            const nextIndex = currIndex + 1;

            return Object.values(CheckoutPage).length > nextIndex;
        },
        chargeableCountries():ISelectCountry[] {
            const defaultCode = this.brand === 'companyweb' ? 'be' : 'nl';
            
            return this.countries.filter(c => {
                return defaultCode !== c.code && this.selectedCountries.includes(c);
            });
        }
    },
    actions: {
        async _checkNlVatValidity() {
            this.isCheckingNlVat = true;
            const { vatNumber, registrationNumber } = this.customerDetails;
            this.isValidNlVat = await Ajax.postAsync<boolean>('/ajax/validate-nl-vat', { vat: vatNumber, kvk: registrationNumber });
            this.isCheckingNlVat = false;
        },
        // debounced versie
        checkNlVatValidity: _.debounce(function (this: any) {
            this._checkNlVatValidity()
        }, 250),
        prevPage(): void {
            const currIndex = Object.values(CheckoutPage).indexOf(this.currentPage);
            const prevIndex = currIndex - 1;

            this.currentPage = Object.values(CheckoutPage)[prevIndex];
        },
        nextPage(): void {
            const currIndex = Object.values(CheckoutPage).indexOf(this.currentPage);
            const nextIndex = currIndex + 1;

            this.currentPage = Object.values(CheckoutPage)[nextIndex];
        },
        setRenewOrderStarted(): void {
            localStorage.setItem("trialRenewStart", Date());
        }
    }
});
